import { render } from "./AllocatedBackorderHistoryReports.vue?vue&type=template&id=40210eba"
import script from "./AllocatedBackorderHistoryReports.vue?vue&type=script&lang=js"
export * from "./AllocatedBackorderHistoryReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__